module.exports = __webpack_public_path__ + "static/media/blue-card-3.0615023d.png";